import { render, staticRenderFns } from "./batchImportModal.vue?vue&type=template&id=5751b244&scoped=true"
import script from "./batchImportModal.vue?vue&type=script&lang=js"
export * from "./batchImportModal.vue?vue&type=script&lang=js"
import style0 from "./batchImportModal.vue?vue&type=style&index=0&id=5751b244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751b244",
  null
  
)

export default component.exports